import { useEffect, useState } from "react";
import ArticleCard from "../compnents/cards/ArticleCard";
import { BASE_URL } from "../config/constants";
import Cookie from "js-cookie";
import { useTranslation } from "react-i18next";

export default function LearningPaths() {
  const { t } = useTranslation();

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log("🚀 LearningPaths component is rendering!");

  // Media API functions
  const getMediaInfo = async (mediaId) => {
    try {
      console.log("📡 Fetching media info for ID:", mediaId);

      const response = await fetch(`${BASE_URL}/api/v1/media/${mediaId}/info`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookie.get("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch media info");
      }

      const data = await response.json();
      console.log("✅ Media info fetched:", data);
      return data;
    } catch (error) {
      console.error("❌ Error fetching media info:", error);
      return null;
    }
  };

  // Fetch tags from API
  const fetchTags = async () => {
    try {
      console.log("📡 STARTING TO FETCH TAGS...");
      setLoading(true);
      setError(null);

      // تحقق من وجود التوكن
      const token = Cookie.get("token");
      console.log("🔑 Token exists:", !!token);

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await fetch(`${BASE_URL}/api/v1/tags`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("📊 Response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ API Error:", errorText);
        throw new Error(`Failed to fetch tags: ${response.status}`);
      }

      const tagsData = await response.json();
      console.log("✅ Tags fetched successfully:", tagsData);

      if (!tagsData || tagsData.length === 0) {
        console.log("ℹ️ No tags found");
        setCourses([]);
        return;
      }

      // معالجة البيانات
      const transformedCourses = await Promise.all(
        tagsData.map(async (tag, index) => {
          console.log(
            `🔄 Processing tag ${index + 1}/${tagsData.length}:`,
            tag
          );

          let imageUrl = getImageByIndex(index);

          // FIXED: Improved image URL logic
          if (tag.media) {
            console.log("📸 Media object:", tag.media);

            // Try direct URL first
            if (tag.media.url && isValidUrl(tag.media.url)) {
              imageUrl = tag.media.url;
              console.log("✅ Using direct media URL:", imageUrl);
            }
            // Try to construct URL from key
            else if (tag.media.key) {
              // Use the download endpoint for media files
              imageUrl = `${BASE_URL}/api/v1/media/${tag.media.id}`;
              console.log("✅ Using media download URL:", imageUrl);
            }
            // Fetch media info if we have media ID
            else if (tag.media.id) {
              console.log("🔍 Fetching media info for ID:", tag.media.id);
              const mediaInfo = await getMediaInfo(tag.media.id);
              if (mediaInfo?.url && isValidUrl(mediaInfo.url)) {
                imageUrl = mediaInfo.url;
                console.log("✅ Using media info URL:", imageUrl);
              } else if (mediaInfo?.id) {
                // Fallback to download endpoint
                imageUrl = `${BASE_URL}/api/v1/media/${mediaInfo.id}`;
                console.log("✅ Using fallback media URL:", imageUrl);
              }
            }
          }

          const course = {
            id: tag.id,
            title: tag.name || "Unnamed Course",
            subtitle: tag.description || getSubtitleByIndex(index),
            courses: tag.courseCount || 1,
            img: imageUrl,
            path: `/courses/${tag.id}`,
          };

          console.log("🎯 Final course object:", course);
          return course;
        })
      );

      setCourses(transformedCourses);
      console.log("🎯 Courses transformed successfully");
    } catch (err) {
      console.error("❌ Error in fetchTags:", err);
      setError(err.message);
    } finally {
      setLoading(false);
      console.log("🏁 Fetching completed");
    }
  };

  // Helper function to validate URLs
  const isValidUrl = (url) => {
    if (!url) return false;
    if (typeof url !== "string") return false;
    if (url.includes("undefined") || url.includes("null")) return false;
    if (url.trim() === "") return false;
    return true;
  };

  // Helpers
  const getSubtitleByIndex = (index) => {
    const subtitles = [
      "معالجة اللغة الطبيعية",
      "تحليل البيانات",
      "الذكاء الاصطناعي",
      "تعلم الآلة",
      "الرؤية الحاسوبية",
      "علم البيانات",
    ];
    return subtitles[index % subtitles.length] || "مسار تعليمي متقدم";
  };

  const getImageByIndex = (index) => {
    const images = [
      "/images/1.png",
      "/images/2.png",
      "/images/3.png",
      "/images/4.png",
      "/images/5.png",
      "/images/6.png",
    ];
    return images[index % images.length] || "/images/10.png";
  };

  useEffect(() => {
    console.log("🎯 useEffect is running");
    fetchTags();
  }, []);

  // UI
  console.log(
    "🎨 Rendering UI, loading:",
    loading,
    "error:",
    error,
    "courses count:",
    courses.length
  );

  if (loading) {
    return (
      <section className="flex flex-col items-center justify-center py-10 mt-36">
        <h2 className="text-xl font-bold mb-4">اختر مسارك التعليمي</h2>
        <div className="animate-pulse text-gray-500">
          جاري تحميل المسارات التعليمية...
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="flex flex-col items-center justify-center py-10 mt-36">
        <h2 className="text-xl font-bold mb-4">اختر مسارك التعليمي</h2>
        <div className="text-red-500">خطأ في تحميل البيانات: {error}</div>
      </section>
    );
  }

  console.log("✅ Showing courses grid");
  return (
    <section className="mt-24">
      <section className="bg-main h-[35vh] md:h-[50vh] flex justify-center items-center mb-16">
        <h2 className="text-2xl md:text-5xl text-white font-semibold">
          {t("roadMap")}
        </h2>
      </section>
      {courses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {courses.map((item) => (
            <ArticleCard
              key={item.id}
              title={item.title}
              description={""}
              image={item.img}
              courses={""}
              path={item.path}
            />
          ))}
        </div>
      ) : (
        <p>لا توجد مسارات تعليمية متاحة حالياً</p>
      )}
    </section>
  );
}
